module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAzMzY2Ij48cGF0aCBkPSJNNDQwLTQ0MHYtMTYwaDgwdjgwaDgwdjgwSDQ0MFptMjgwIDB2LTgwaDgwdi04MGg4MHYxNjBINzIwWk00NDAtNzIwdi0xNjBoMTYwdjgwaC04MHY4MGgtODBabTM2MCAwdi04MGgtODB2LTgwaDE2MHYxNjBoLTgwWk0xMzYtODBsLTU2LTU2IDIyNC0yMjRIMTIwdi04MGgzMjB2MzIwaC04MHYtMTg0TDEzNi04MFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-jump-ovbblue.svg
// module id = 529
// module chunks = 0